import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {deleteOffice, getOffice} from "../../actions/Office";
function OfficesList() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [offices, setOffices] = useState<any[]>([]);

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    useEffect(() => {
        fetchOffices();
    }, []);

    function fetchOffices() {
        getOffice()
            .then(response => {
                setOffices(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch offices:", error);
            });
    }

    const handleDelete = async (postId: number) => {
        if (window.confirm("Are you sure you want to delete this office?")) {
            try {
                await deleteOffice(postId);
                // After successful delete, reload the data
                fetchOffices();
            } catch (error) {
                console.error("Failed to delete office:", error);
                alert("Failed to delete the office. Please try again.");
            }
        }
    };

    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

        <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
            <div className="content-form-button right-align">
                <button
                    type="button"
                    className="button button-right"
                    onClick={() => navigate('/dashboard/offices/add', { state: { user } })}
                >
                    Add New Office
                </button>
            </div>

            <div className="table-container">
                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "81%" }}>Provinces</th>
                            <th style={{ width: "11%" }}>View / Edit</th>
                            <th style={{ width: "8%" }}>Delete</th>
                        </tr>
                        </thead>
                        <tbody>
                        {offices.map((post) => (

                            <tr key={post.id}>
                                <td>{post.province}</td>
                                <td>
                                    <button
                                        className="button small"
                                         onClick={() => navigate(`/dashboard/offices/${post.id}/edit`, { state: { user } })}
                                        style={{ marginRight: "10px" }}
                                    >
                                        View / Edit
                                    </button>
                                </td>
                                <td>
                                    <button
                                        className="button small danger"
                                        onClick={() => {
                                            handleDelete(post.id)}
                                        }

                                        style={{ color: "black" }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
}

export default OfficesList;
